import React, {useEffect, useState} from 'react'
import {IRoles, IRouteSenderRoles} from './_model'
import {BASE_URL} from '../config'
import usePaginationCounts from '../../utils/hooks/usePaginationCounts'
import {useQuery} from 'react-query'
import axios from 'axios'
import {IPagination} from '../../utils/core/_model'
import {useRouteManagement} from './RouteManagementProvider'
import {searchItems} from '../../utils/helperFunction/_helper'
import {ListViewProvider} from '../../utils/contextProvider/ListViewProvider'
import TableContentHeader from '../../utils/components/table-content/TableContentHeader'
import TableContent from '../../utils/components/table-content/TableContent'
import routesSenderRolesColumn from './routesSenderRolesColumn'
import TablePagination from '../../utils/components/table-content/TablePagination'
import toast from 'react-hot-toast'

const GET_SENDER_ROLES_LIST_URL = `${BASE_URL}/api/protect/routeSenderRolesList`
const GET_SENDER_ROLE_BY_ID_URL = `${BASE_URL}/api/protect/getRouteSenderRoles`

const RouteSenderRolesList = () => {
  const {searchTerm, setSelectRouteSenderRole} = useRouteManagement()
  const {
    pagination: {totalElement, size, page},
    handlePageChange,
    handlePagePerItem,
    updatePagination,
  } = usePaginationCounts(1, 10)

  const [filteredRouteSenderRoles, setFilteredRouteSenderRoles] = useState<IRouteSenderRoles[]>([])

  const {isLoading, data, error} = useQuery({
    queryKey: ['createRouteSenderRoles', {page, size}],
    queryFn: async () => {
      const response = await axios.get(GET_SENDER_ROLES_LIST_URL, {
        params: {
          page: page,
          size,
        },
      })

      const result = await response.data
      const data = await result.data
      const pagination = await result.pagenationResponse
      // const pagination: IPagination = {
      //   page: result.number,
      //   size: result.size,
      //   number: result.number,
      //   firstPage: result.first,
      //   lastPage: result.last,
      //   totalPages: result.totalPages,
      //   totalElement: result.totalElements,
      // }

      //   console.log(result)
      //   console.log(pagination)

      return {
        list: data,
        pagination,
      }
    },
  })

  const handleSelect = async (id: number) => {
    // toast.loading('Processing..')
    // const response = await axios.get(`${GET_SENDER_ROLE_BY_ID_URL}/${id}`)
    // const data = await response.data
    const data = filteredRouteSenderRoles.find((role) => role.id === id)

    if (data) {
      setSelectRouteSenderRole(data)
      toast.dismiss()
    }
  }

  useEffect(() => {
    if (data && data.list && data.pagination) {
      const keys: (keyof IRouteSenderRoles)[] = ['name', 'type']
      console.log(data.list)

      const filtered = searchItems(data.list, searchTerm, keys)

      setFilteredRouteSenderRoles(filtered)

      updatePagination(data.pagination)
    } else {
      setFilteredRouteSenderRoles([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchTerm])

  return (
    <div>
      <ListViewProvider data={filteredRouteSenderRoles} isLoading={isLoading}>
        <TableContentHeader size={size} handlePagePerItem={handlePagePerItem} />
        <TableContent
          isLoading={isLoading}
          error={error as Error}
          tableData={filteredRouteSenderRoles}
          tableColumn={routesSenderRolesColumn(handleSelect)}
        >
          {isLoading && !data ? (
            <div className='d-flex justify-content-center'>
              <div className='spinner-border' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : (
            <TablePagination
              totalElement={totalElement}
              isLoading={isLoading}
              itemsPerPage={size}
              currentPage={page}
              handlePageChange={handlePageChange}
            />
          )}
        </TableContent>
      </ListViewProvider>
    </div>
  )
}

export default RouteSenderRolesList
